import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Bell, Search } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Button } from '@/components/atoms/button';
import { Input } from '@/components/atoms/input';
import { MobileNav } from '../sidebar/mobile-nav';
import { UserMenu } from './user-menu';
import { LanguageSwitcher } from './language-switcher';
import { CurrencySwitcher } from './currency-switcher';

interface HeaderProps {
  className?: string;
}

export function Header({ className }: HeaderProps) {
  const { t } = useTranslation();

  return (
    <header
      className={cn(
        'sticky top-0 z-40 flex h-16 items-center gap-4 border-b bg-background px-4 md:px-6',
        className
      )}
    >
      {/* Mobile Nav Toggle */}
      <MobileNav />

      {/* Logo for mobile */}
      <div className="flex lg:hidden items-center gap-2">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
            <span className="text-primary-foreground font-bold text-lg">V</span>
          </div>
        </Link>
      </div>

      {/* Search */}
      <div className="hidden md:flex flex-1 max-w-md">
        <div className="relative w-full">
          <Search className="absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            type="search"
            placeholder={`${t('common.search')}...`}
            className="w-full pl-9"
          />
        </div>
      </div>

      {/* Right side */}
      <div className="ml-auto flex items-center gap-2">
        {/* Hidden on mobile - available in Settings */}
        <div className="hidden sm:flex items-center gap-2">
          <CurrencySwitcher />
          <LanguageSwitcher />
          <Button variant="ghost" size="icon" className="relative">
            <Bell className="size-5" />
            <span className="absolute top-1.5 right-1.5 size-2 rounded-full bg-destructive" />
            <span className="sr-only">Notifications</span>
          </Button>
        </div>

        <UserMenu />
      </div>
    </header>
  );
}
